<span #browseFilesButton class="btn btn-sm btn-success" style="border-radius: 8px">
  <i class="icon icon-file"></i>
  Import session file
</span>
